import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ImImportService} from "../../../../service/api/im-import.service";
import {OverviewKpiBaseComponent} from "../../../../../../core/shared/overview/overview-kpi-base.component";
import {KpiHeaderDto} from "../../../../../../core/shared/overview/dto/kpi-header.dto";
import {MenuItem} from "primeng/api";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";


@Component({
    selector: 'im-kpi-component',
    templateUrl: 'im-kpi.component.html',
    standalone: false
})
export class ImKpiComponent extends OverviewKpiBaseComponent implements OnInit, OnChanges, OnDestroy {

    importRecordService: MvsCrudService;
    totalImports: number = 0;
    totalImportRecords: number = 0;
    thisMonthImports: number = 0;
    thisWeekImports: number = 0;

    kpiHeaderDto: KpiHeaderDto[];
    items: MenuItem[] | undefined = [{label: 'IM Module'}];

    constructor(
        protected coreService: MvsCoreService,
        
        protected importService: ImImportService) {
        super()

        this.importRecordService = this.coreService.getCrudService("im.ImImportRecord");
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        this.getTotalImports();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    getTotalImports() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['severity'],
            [new ObjectRequestListAttribute('severity', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.importService.groupBy(objectRequestList).subscribe(res => {
            this.totalImports = res.entries.reduce((acc, item) => acc + item['severity_count'], 0);
            this.getTotalImportRecords();
        }, error => {
            this.getTotalImportRecords();
        });
    }

    getTotalImportRecords() {
        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['status'],
            [new ObjectRequestListAttribute('status', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.importRecordService.groupBy(objectRequestList).subscribe(res => {
            this.totalImportRecords = res.entries.reduce((acc, item) => acc + item['status_count'], 0);
            this.getThisMonthImports();
        }, error => {
            this.getThisMonthImports();
        });
    }

    getThisMonthImports() {
        const objectRequestList = this.getThisMonthRequest('severity');
        this.importService.groupBy(objectRequestList).subscribe(res => {
            this.thisMonthImports = res.entries.reduce((acc, item) => acc + item['severity_count'], 0);
            this.getThisWeekImports();
        }, error => {
            this.getThisWeekImports();
        });
    }

    getThisWeekImports() {
        const objectRequestList = this.getThisWeekRequest('severity');
        this.importService.groupBy(objectRequestList).subscribe(res => {
            this.thisWeekImports = res.entries.reduce((acc, item) => acc + item['severity_count'], 0);
            this.initKpiHeaderDto();
        }, error => {
            this.initKpiHeaderDto();
        });
    }


    initKpiHeaderDto() {

        this.kpiHeaderDto = [
            {
                label: 'Total Imports', value: [this.totalImports],
            },
            {
                label: 'Total Import Records', value: [this.totalImportRecords],
            },
            {
                label: 'This Month Imports', value: [this.thisMonthImports],
            },
            {
                label: 'This Week Imports', value: [this.thisWeekImports],
            },
        ]
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
